<template>
  <Popup class="course-materials-popup" @close="close">
    <div class="text-container">
      <p class="title">Course Materials</p>
      <p class="subtitle">Select the material you want to view below.</p>
    </div>

    <div class="buttons">
      <button type="button" class="download-button" :disabled="!videoLink" @click="downloadVideo">
        <img :src="$assets.svg['recordedVideo_icon']" alt="" />
        Welcome Video
      </button>
      <div class="line" />
      <button type="button" class="download-button" :disabled="!pptLink" @click="downloadPPT">
        <img :src="$assets.svg['powerpoint_icon']" alt="" />
        PowerPoint
      </button>
      <div class="line" />
      <button type="button" class="download-button" :disabled="!docLink" @click="downloadDoc">
        <img :src="$assets.svg['wordDoc_icon']" alt="" />
        Workbook
      </button>
      <div class="line" />
      <button type="button" class="download-button" :disabled="!pdfLink" @click="downloadPDF">
        <img :src="$assets.svg['pdf_icon']" alt="" />
        PDF
      </button>
    </div>
  </Popup>
</template>

<script setup>
import $assets from '@/assets';
import Popup from '@/components/event/Popup.vue';

const emit = defineEmits(['close']);
const props = defineProps({
  pdfLink: {
    type: String,
    default: null,
  },
  docLink: {
    type: String,
    default: null,
  },
  pptLink: {
    type: String,
    default: null,
  },
  videoLink: {
    type: String,
    default: null,
  },
});

function downloadPDF() {
  window.open(props.pdfLink, '_blank');
}
function downloadDoc() {
  window.open(props.docLink, '_blank');
}
function downloadPPT() {
  window.open(props.pptLink, '_blank');
}
function downloadVideo() {
  window.open(props.videoLink, '_blank');
}

function close() {
  emit('close');
}
</script>

<style scoped>
.course-materials-popup :deep(.popup-window) {
  width: 75%;
  max-width: 996px;
  height: unset;

  font-family: Helvetica;
  color: #ffffff;
  text-align: center;

  background: #16afc7;
  border-radius: 2em;
}

.course-materials-popup :deep(.popup-content) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-container {
  position: absolute;
  top: 10px;
  margin: 0 auto;
}

.title {
  margin-bottom: 0;
  font-size: 2.3em;
}

.subtitle {
  margin-top: 0;
  font-size: 1.1em;
}

.buttons {
  position: relative;
  top: 10px;
  width: 100%;
  margin: 7em 1em 4em 1em;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}

.download-button {
  min-width: 112px;

  font-family: Helvetica;
  font-size: 1em;
  color: #ffffff;
  text-align: center;

  background-color: transparent;
  box-shadow: none;
  border: none;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.download-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.download-button > img {
  height: 100px;
}

.line {
  display: none;

  height: 127px;
  border: 1px solid #ffffff;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .text-container {
    top: 0;
  }

  .buttons {
    width: 400px;
    margin: 7em 80px 4em 80px;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .text-container {
    top: 0;
  }

  .buttons {
    width: 661px;
    margin: 142px 80px;
  }

  .download-button > img {
    margin: 17px 0 40px 0;
  }

  .line {
    display: block;
  }
}
</style>
